/** * @description: 工单详情右侧tab管理 * @author: */
<template>
  <div class="detail-right">
    <el-tabs v-model="activeName" class="detail-tabs">
      <template v-for="tab in tabs">
        <el-tab-pane v-if="tab === 'woQuality'" :label="$lang('工单质检')" :name="tab" :key="tab" lazy>
          <slot v-if="$slots.woQuality" name="woQuality" />
          <div class="model-preview" v-else>
            <modelWorkOrder></modelWorkOrder>
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="tab === 'ccQuality'" :label="$lang('语音质检')" :name="tab" :key="tab" lazy>
          <slot v-if="$slots.ccQuality" name="ccQuality" />
        </el-tab-pane>
        <el-tab-pane v-if="tab === 'imQuality'" :label="$lang('IM质检')" :name="tab" :key="tab" lazy>
          <span slot="label">
            {{ names[tab] || $lang('IM质检') }}
            <span class="total-view">{{ imModelTableLength }}</span>
          </span>
          <div class="model-preview">
            <modelPreview type="viewPage" @postModelData="postModelData"></modelPreview>
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="tab === 'handleQt'" :label="names[tab] || $lang('质检记录')" :name="tab" :key="tab">
          <slot v-if="$slots.handleQt" name="handleQt" />
          <qt-detail-handle-list v-else :option="handleQt" />
        </el-tab-pane>
        <el-tab-pane
          v-if="tab === 'handle'"
          :label="names[tab] || $lang('问题处理记录')"
          :name="tab"
          :key="tab"
          lazy
        >
          <slot v-if="$slots.handle" name="handle" />
          <detail-handle-list v-else :option="handle" />
        </el-tab-pane>
        <!-- <el-tab-pane
          v-if="tab === 'base'"
          :label="names[tab] || $lang('基础信息')"
          :name="tab"
          :key="tab"
          lazy
        >
          <slot v-if="$slots.base" name="base" />
          <detail-base-info
            v-else
            :value="orderInfo"
            :encryption="encryption"
            @decode="getOrderInfo({waybillNo:code, decode:true})"
            :show-warn="showInfoWarn"
          />
        </el-tab-pane> -->
        <el-tab-pane v-if="tab === 'trail'" :name="tab" :key="tab">
          <template slot="label">
            <span class="label-margin">{{
              names[tab] || $lang('物流轨迹')
            }}</span>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$lang('查询全部')"
              placement="top"
            >
              <el-checkbox v-if="allPodSwitch" v-model="findAllPod" />
            </el-tooltip>
          </template>
          <detail-step-bar
            v-if="showStepBar  && (trailList.length||ExternalNetworkList.length)" :prescriptionData="prescriptionData"
            :trailList="trailList.length?trailList:ExternalNetworkList"
          ></detail-step-bar>
          <slot v-if="$slots.trail" name="trail" />
          <logistics-track ref="track"
            :tabs="tabs"
            :trailList="trailList"
            :ExternalNetworkList="ExternalNetworkList"
            :orderInfo="orderInfo"
            :option="trail"
            :waybillNo="waybillNo"
            :showWarn="showInfoWarn"
            :trailErrorMsg="trailErrorMsg"
            :firstTrailList="firstTrailList"
            :secondTrailList="secondTrailList"
            :waringData="waringData"
            @getAddressDetail="getAddressDetail"
            @changeTrackType="getTrailListWorkOrder"
            :showbackTransfer="showbackTransfer"
            :showPickupInfo="showPickupInfo"
            :inputType="inputType"
            :orderNo="orderNo"
            :showCancelBtn="showCancelBtn"
            @looseOrderStatus="$emit('looseOrderStatus', $event)"
          >
            <template v-if="$slots.base" slot="base">
              <slot name="base" />
            </template>
            <template v-if="$slots.trail" slot="trail">
              <slot name="trail" />
            </template>
          </logistics-track>
        </el-tab-pane>

        <!-- <el-tab-pane v-if="tab === 'immortalTrail'" :name="tab" :key="tab" lazy>
          <span slot="label">
            {{names[tab] || $lang('物流轨迹-BS')}}
            <span class="total-view" v-if="immortalTrailList.length">{{immortalTrailList.length}}</span>
          </span>
          <slot v-if="$slots.immortalTrail" name="immortalTrail" />
          <div style="padding-left: 0px;padding-top: 0px;width: 99%;">
            <detail-list-table :msg="immortalTrailListErrorMsg" :value="immortalTrailList" :option="immortalTrail" >
            </detail-list-table>
          </div>
        </el-tab-pane> -->

        <el-tab-pane v-if="tab === 'problem'" :name="tab" :key="tab" lazy>
          <span slot="label">
            {{ names[tab] || $lang('问题件详情') }}
            <span class="total-view" v-if="problemList.length || problemDetailErrorMsg!==''">{{
              problemList.length
            }}</span>
          </span>
          <slot v-if="$slots.problem" name="problem" />
          <detail-list-table
            v-else
            :msg="problemDetailErrorMsg"
            :value="problemList"
            :option="problem"
            @detailId="getProblemMinList"
          >
            <template slot="urlsSlot" slot-scope="{ item }">
              <span
                v-if="item.urls.length"
                class="link-color pointer-view"
                @click="handleShowImg(item.urls)"
                >{{ $lang('查看图片') }}({{ item.urls.length }})</span
              >
            </template>
            <detail-min-table
              slot="detailView"
              :value="problemMinList"
              :option="problemMin"
            >
              <template slot="urlsSlot" slot-scope="{ item }">
                <span
                  v-if="item.urls.length"
                  class="link-color pointer-view"
                  @click="handleShowImg(item.urls)"
                  >{{ $lang('查看附件') }}({{ item.urls.length }})</span
                >
              </template>
            </detail-min-table>
          </detail-list-table>
        </el-tab-pane>
        <!-- <el-tab-pane v-if="tab === 'workOrder'" :name="tab" :key="tab" lazy>
          <span slot="label">
            {{ names[tab] || $lang('工单/理赔') }}
            <span class="total-view" v-if="workOrderList.length || workOrderListAll.length || workOrderListErrorMsg!==''">{{
              workOrderList.length + workOrderListAll.length
            }}</span>
          </span>
          <slot v-if="$slots.workOrder" name="workOrder" />
          <detail-list-table-all
            v-else
            :msg="workOrderListErrorMsg"
            :value="workOrderListAll"
            :option="workOrder"
            @getItem="setWorkOrderMinListAll"
            hideBtn
          >
            <detail-min-table
              slot="detailView"
              :value="workOrderMinListAll"
              :option="workOrderMin"
            >
            </detail-min-table>
            <detail-list-table
              slot="detailList"
              :value="workOrderList"
              :option="workOrder"
              @getItem="setWorkOrderMinList"
              hideBtn
            >
              <detail-min-table
                slot="detailView"
                :value="workOrderMinList"
                :option="workOrderMin"
              >
              </detail-min-table>
            </detail-list-table>
          </detail-list-table-all>
        </el-tab-pane> -->
        <el-tab-pane v-if="tab === 'CustomerServiceOrder'" :name="tab" :key="tab" lazy>
          <span slot="label">
            {{names[tab] || $lang('客服工单')}}
            <span class="total-view" v-if="customerServiceOrder.num ">{{customerServiceOrder.num}}</span>
          </span>
          <slot v-if="$slots.workOrder" name="CustomerServiceOrder" />
          <CustomerServiceOrder :customerServiceOrder="customerServiceOrder"/>
        </el-tab-pane>
        <!-- <el-tab-pane v-if="tab === 'arbitration'" :name="tab" :key="tab" lazy>
          <span slot="label">
            {{ names[tab] || $lang('仲裁工单') }}
            <span class="total-view" v-if="arbitrationList.length|| arbitrationListErrorMsg!==''">{{
              arbitrationList.length
            }}</span>
          </span>
          <slot v-if="$slots.arbitration" name="arbitration" />
          <detail-list-table
            v-else
            :msg="arbitrationListErrorMsg"
            :value="arbitrationList"
            :option="arbitration"
          />
        </el-tab-pane> -->
        <!-- <el-tab-pane v-if="tab === 'quality'" :name="tab" :key="tab" lazy>
          <span slot="label">
            {{ names[tab] || $lang('质量工单') }}
            <span class="total-view" v-if="qualityList.length || qualityListErrorMsg!==''">{{
              qualityList.length
            }}</span>
          </span>
          <slot v-if="$slots.quality" name="quality" />
          <detail-list-table
            v-else
            :msg="qualityListErrorMsg"
            :value="qualityList"
            :option="quality"
            @getItem="setQualityMinList"
          >
            <template slot="urlsSlot" slot-scope="{ item }">
              <span
                v-if="item.problemPieceAttachment.length"
                class="link-color pointer-view"
                @click="handleShowImg(item.problemPieceAttachment, 'path')"
                >{{ $lang('查看图片') }}({{
                  item.problemPieceAttachment.length
                }})</span
              >
            </template>
            <detail-min-table
              slot="detailView"
              :value="qualityMinList"
              :option="qualityMin"
            >
              <template slot="urlsSlot" slot-scope="{ item }">
                <span
                  v-if="item.problemPieceAttachment.length"
                  class="link-color pointer-view"
                  @click="handleShowImg(item.problemPieceAttachment, 'path')"
                  >{{ $lang('查看图片') }}({{
                    item.problemPieceAttachment.length
                  }})</span
                >
              </template>
              <template slot="filesSlot" slot-scope="{ item }">
                <span
                  v-if="item.proofAttachment.length"
                  class="link-color pointer-view"
                  @click="handleShowImg(item.proofAttachment, 'path')"
                  >{{ $lang('查看图片') }}({{
                    item.proofAttachment.length
                  }})</span
                >
              </template>
            </detail-min-table>
          </detail-list-table>
        </el-tab-pane> -->

        <!-- 来电记录 -->
        <el-tab-pane v-if="tab === 'CallRecords'" :name="tab" :key="tab" lazy>
          <span slot="label">
            {{names[tab] || $lang('来访/短信记录')}}
            <span class="total-view" v-if="recordTotal">{{recordTotal}}</span>
          </span>
          <slot v-if="$slots.CallRecords" name="CallRecords" />
          <el-collapse v-model="activeNames">
            <el-collapse-item name="1">
              <span
                class="order-title"
                slot="title"
              >
                <span
                  class="total-view"
                  v-if="(CallRecordsList||[]).length"
                >{{(CallRecordsList||[]).length||''}}</span>
                {{$lang('来访记录')}}
              </span>
              <el-collapse-transition>
                <div style="margin:10px auto">
                  <detail-list-table @showPhoneEyes="showPhoneEyes"  :msg="callRecordsErrorMsg"  :value="CallRecordsList" :option="CallRecords" >
                  </detail-list-table>
                </div>
              </el-collapse-transition>
            </el-collapse-item>
            <el-collapse-item name="2">
              <span
                class="order-title"
                slot="title"
              >
                <span
                  class="total-view"
                  v-if="(smsLogsErrorList||[]).length"
                >{{(smsLogsErrorList||[]).length||''}}</span>
                {{$lang('短信记录')}}
              </span>
              <el-collapse-transition>
                <div style="margin:10px auto">
                  <detail-list-table @showPhoneEyes="showPhoneEyes"  :msg="smsLogsErrorMsg"  :value="smsLogsErrorList" :option="SmsLogs" >
                  </detail-list-table>
                </div>
              </el-collapse-transition>
            </el-collapse-item>
            <el-collapse-item name="3"  v-if="isPickupcode">
              <span
                class="order-title"
                slot="title"
              >
                  <span
                  class="total-view"
                  v-if="(PickupcodeList||[]).length"
                >{{(PickupcodeList||[]).length||''}}</span>
                {{$lang('取件码')}}
              </span>
              <el-collapse-transition>
                <div style="margin:10px auto">
                  <detail-list-table :msg="PickupCodeErrorMsg" :value="PickupcodeList" :option="Pickupcode" >
                  </detail-list-table>
                </div>
              </el-collapse-transition>
            </el-collapse-item>
          </el-collapse>
        </el-tab-pane>
        <!-- 邮政工单 -->
        <!-- <el-tab-pane v-if="tab === 'postalOrder'" :name="tab" :key="tab" lazy>
          <span slot="label">
            {{names[tab] || $lang('邮政工单')}}
            <span class="total-view" v-if="postalOrderAllList.length|| postalOrderErrorMsg !== ''">{{postalOrderAllList.length}}</span>
          </span>
          <slot v-if="$slots.postalOrder" name="postalOrder" />
          <detail-list-table-all v-else :msg="postalOrderErrorMsg" :value="postalOrderAllList" :option="postalOrder" @getItem="setPostalOrderList" hideBtn>
            <detail-min-table slot="detailView" :value="postalOrderList" :option="postalOrderMin">
              </detail-min-table>
          </detail-list-table-all>
        </el-tab-pane> -->

        <el-tab-pane
          v-if="!~initTabs.indexOf(tab) && names && names[tab]"
          :label="names[tab]"
          :name="tab"
          :key="tab"
          lazy
        >
          <slot :name="tab" />
        </el-tab-pane>
      </template>
    </el-tabs>
  </div>
</template>

<script>
import { detailView, BackTransferApi } from '../pool'
import {
  trail,
  handle,
  handleQt,
  problem,
  problemMin,
  workOrder,
  workOrderMin,
  arbitration,
  quality,
  qualityMin,
  CallRecords,
  immortalTrail,
  postalOrder,
  postalOrderMin,
  SmsLogs,
  Pickupcode
} from './option';
import { RESPONSE_CODE } from '@public/http/config';
import showOrderSignMixin from '@/common/mixin/showOrderSignMixin'
import modelPreview from '@/views/quality-testing/model-manage/modelPreview.vue'
import modelWorkOrder from '@/views/quality-testing/model-manage/modelWorkOrder.vue'

export default {
  name: 'RightDetail',
  components: {
    modelPreview, modelWorkOrder
  },
  mixins: [showOrderSignMixin],
  data() {
    const POD_option = {
      ...trail,
      copyBtn: this.copyBtn,
      showNetInfo: this.showNetInfo,
      abnormalTask: this.abnormalTask,
      showStopList: this.showStopList,
      showPackInfo: this.showPackInfo,
      showNetLast: this.showNetLast

    };
    return {
      activeNames: ['1', '2', '3'],
      // 已经默认配置的tab
      initTabs: [
        'handle',
        'trail',
        'base',
        'workOrder',
        'arbitration',
        'problem',
        'quality'
      ],
      orderInfo: {},
      activeName: this.active || this.tabs[0],
      trail: POD_option,
      trailList: [],
      ExternalNetworkList: [], // 官网轨迹
      firstTrailList: [], // 一联
      secondTrailList: [], // 二联
      handle,
      handleQt,
      workOrder,
      workOrderList: [],
      workOrderMinListAll: [],
      workOrderListAll: [],
      workOrderMin,
      workOrderMinList: [],
      problem,
      problemList: [],
      problemMin,
      problemMinList: [],
      arbitration,
      arbitrationList: [],
      quality,
      qualityList: [],
      qualityMin,
      qualityMinList: [],
      CallRecords, // 来电记录option
      CallRecordsList: [], // 来电记录数据
      trailErrorMsg: '', // 物流报错信息
      callRecordsErrorMsg: '', // 来电记录报错信息
      problemDetailErrorMsg: '', // 问题件报错信息
      workOrderListErrorMsg: '', // 工单/理赔报错信息
      arbitrationListErrorMsg: '', // 仲裁报错信息
      qualityListErrorMsg: '', // 质量工单报错信息
      immortalTrail,
      // immortalTrailList: [],
      // immortalTrailListErrorMsg: '', // 百世物流轨迹报错信息
      findAllPod: false, // 全部物流开关
      isBs: false, // 百世物流
      checkBs: false, // 百世反查状态
      postalOrder,
      postalOrderMin,
      postalOrderList: [], // 邮政工单tab里层
      postalOrderAllList: [], // 邮政工单外层
      postalOrderErrorMsg: '', // 邮政工单报错信息
      SmsLogs,
      smsLogsErrorMsg: '',
      smsLogsErrorList: [],
      customerServiceOrder: {
        num: 0,
        workOrderListAll: [],
        postalOrderAllList: [],
        arbitrationList: [],
        qualityList: []
      }, // 客服工单
      routeName: '',
      // customerPhone: '',
      waringData: {},
      imModelTableLength: 0, // IM质检个数
      // 取件码
      PickupcodeList: [],
      PickupTotal: 0,
      Pickupcode,
      PickupCodeErrorMsg: '',
      // 是否展示退回按钮
      showbackTransfer: false
    };
  },
  props: {
    pageType: String,
    waybillNo: String,
    encryption: Boolean,
    active: String,
    copyBtn: Boolean, // 一键输入
    showNetInfo: Boolean, // 物流轨迹查网点联系信息
    abnormalTask: Boolean, // 物流轨迹查异常任务信息
    showStopList: Boolean, // 展示经停列表
    showPackInfo: Boolean, // 展示包号信息
    showInfoWarn: Boolean, // 展示基本信息警告
    showNetLast: Boolean, // 展示下一站联系方式信息
    tabs: {
      type: Array,
      default: () => ['handle', 'workOrder', 'trail', 'base']
    },
    names: {
      type: Object,
      default: () => ({})
    },
    logoTitle: {
      // 增加各个页面反查标识符
      type: String,
      default: ''
    },
    allPodSwitch: Boolean, // 展示全部物流轨迹开关
    trailAll: Boolean, // 直接请求全部物流轨迹
    reversePOD: Boolean, // 物流轨迹倒序
    showStepBar: Boolean, // 是否显示时效限制进度条
    prescriptionData: { // 时效数据
      type: Object,
      default: () => {}
    },
    customerPhone: [String, Number],
    isPickupcode: Boolean, // 展示取件码
    isAppeal: Boolean,
    showPickupInfo: Boolean, // 是否显示取件信息面板
    inputType: String, // 输入类型：waybillNo 或 orderNo
    orderNo: String, // 订单号
    showCancelBtn: Boolean // 是否显示取消订单按钮
  },
  created() {
    // 父级做事件巴士
    this.$parent.$on('waybillNo', code => {
      this.handleRefresh(code);
    });
    // 接受兄弟组件Bs
    this.$bus.$on('getBsTrack', params => {
      const { isBs } = params
      this.isBs = isBs
    })
    this.$bus.$on('getOrderId', code => {
      this.isOrder = true
      if (code) {
        this.getOrderInfo({ orderId: code, isOrder: true })
      } else {
        this.orderInfo = {}
      }
    })
  },
  mounted() {
    this.routeName = this.$route.name
  },
  destroyed() {
    this.$parent.$off('waybillNo');
    this.$parent.$off('getBsTrack')
    this.$parent.$off('getOrderId')
    // this.$bus.$off('setCustomerPhone')
  },
  watch: {
    waybillNo(code) {
      this.handleRefresh(code);
      this.isAppeal && this.getCustomerType()
    },
    activeName(name) {
      this.$emit('getActive', name);
    },
    allPod(val) {
      this.code && this.getTrailList(this.code, true);
      this.$parent.$emit('getIsAll', val);
    },
    active: {
      deep: true,
      handler(newVal, oldVal) {
        this.activeName = this.active
      }
    },
    customerPhone: {
      immediate: true,
      handler(newVal) {
        if (this.isShowWaring && this.routeName === this.$route.name) {
          this.getWaringData()
          this.isAppeal && this.getCustomerType()
        }
      }
    }
  },
  computed: {
    isShowWaring() {
      return ['callCenter', 'imService'].includes(this.$route.name)
    },
    // 客服工单
    isCustomerService() {
      return this.tabs.includes('CustomerServiceOrder')
    },
    allPod() {
      return this.trailAll || this.findAllPod;
    },
    // 来访/短信总数
    recordTotal() {
      return (this.CallRecordsList.length || 0) + (this.smsLogsErrorList.length || 0) + (this.PickupcodeList.length || 0)
    }
  },
  methods: {
    resetErrorMsg() {
      this.trailErrorMsg = ''
      // this.immortalTrailListErrorMsg = ''
      this.problemDetailErrorMsg = ''
      this.workOrderListErrorMsg = ''
      this.arbitrationListErrorMsg = ''
      this.qualityListErrorMsg = ''
      this.callRecordsErrorMsg = ''
      this.postalOrderErrorMsg = ''
      this.PickupCodeErrorMsg = ''
    },
    handleRefresh(code) {
      this.code = code;
      if (code) {
        if (this.tabs.some(o => o === 'trail') && !this.$slots['trail']) {
          this.getTrailList(code);
        }
        if (this.tabs.some(o => o === 'base') && !this.$slots['base']) {
          this.checkBs = false // 重置BS反查状态
          if (code) {
            this.getOrderInfo({ waybillNo: code });
          }
        }
        if (this.tabs.some(o => o === 'problem') && !this.$slots['problem']) {
          this.getProblemList(code);
        }
        if ((this.tabs.some(o => o === 'workOrder') && !this.$slots['workOrder']) || this.isCustomerService) {
          if (this.getNew !== 'ZLGDBASE') {
            this.getWorkOrderList(code)
          }
        }
        if ((this.tabs.some(o => o === 'arbitration') && !this.$slots['arbitration']) || this.isCustomerService) {
          if (this.getNew !== 'ZLGDBASE') {
            this.getArbitrationList(code)
          }
        }
        if ((this.tabs.some(o => o === 'quality') && !this.$slots['quality']) || this.isCustomerService) {
          this.getQualityList(code)
        }
        // 查询来电记录
        if (this.tabs.some(o => o === 'CallRecords') && !this.$slots['CallRecords']) {
          this.getCallRecords({ waybillNo: code })
          this.getSmslogs({ waybillNo: code })
          if (this.isPickupcode) {
            this.getPickupcode(code)
          }
        }
        // 百世轨迹
        // if (this.tabs.some(o => o === 'immortalTrail') && !this.$slots['immortalTrail']) {
        //   this.isBs && this.getImmortalTrail(code)
        // }
        // 邮政工单
        if ((this.tabs.some(o => o === 'postalOrder') && !this.$slots['PostalOrder']) || this.isCustomerService) {
          this.getPostalInfo(code)
        }
      } else {
        this.orderInfo = {};
        this.trailList = [];
        this.ExternalNetworkList = []
        this.firstTrailList = []
        this.secondTrailList = []
        this.problemList = [];
        this.problemMinList = [];
        this.workOrderList = [];
        this.workOrderListAll = [];
        this.arbitrationList = [];
        this.qualityList = [];
        this.CallRecordsList = [];
        this.smsLogsErrorList = []
        this.PickupcodeList = []
        // this.immortalTrailList = [];
        this.postalOrderList = []
        this.postalOrderAllList = []
        this.resetErrorMsg()
        this.setCustomerServiceOrder()
        this.getWaringData()
      }
    },
    // 切换内官网轨迹
    // 工单区分内网官网轨迹接口
    async getTrailListWorkOrder(waybillNoParam, isAllTime) {
      // this.trailList = []
      // this.ExternalNetworkList = []
      if (this.trailList.length && this.ExternalNetworkList.length && !isAllTime) return
      const waybillNo = waybillNoParam || this.code
      if (!waybillNo) return
      this.trailList = []
      this.ExternalNetworkList = []
      const track = this.$refs.track
      track && (track[0].switchUp = false)
      const isExternal = track ? (track[0].tableType === 2) : false// true:官网
      const params = {
        waybillNo,
        isAllTime: this.allPod, // true查全部
        isExternal
      }
      const trackProp = isExternal ? 'ExternalNetworkList' : 'trailList'
      const { data, msg, code } = await detailView.getTrailListWorkOrder(params);
      if (code === RESPONSE_CODE.SUCCESS) {
        // 返回结构： "运单号": [轨迹],
        if (data && data[waybillNo]) {
          this[trackProp] = data[waybillNo] || []
          this.isShowWaring && waybillNo?.length > 14 && await this.getWaringData()
          // 匹配转运中心数据及到件扫描最后一条数据
          if (this.reversePOD) {
            this[trackProp] = this[trackProp].reverse()
          }
        } else {
          this.isShowWaring && waybillNo?.length > 14 && this.getWaringData()
        }
        !isExternal && this.processData()// (仅内网)
      } else {
        this.isShowWaring && waybillNo?.length > 14 && this.getWaringData()
        this.trailErrorMsg = msg
      }
    },
    // isAllTime=>是否点击的查询全部勾选框
    async getTrailList(waybillNo, isAllTime) {
      if (this.showConsolidation) { // 来自showOrderSignMixin
        this.getTrailListWorkOrder(waybillNo, isAllTime)// 热线和在线使用新接口
        return
      }
      this.trailList = [];
      this.$nextTick(() => {
        this.$refs.track[0].switchUp = false
      })
      const { data, msg, code } = await detailView.traceDataList(this.code, this.allPod);
      if (code === RESPONSE_CODE.SUCCESS) {
        if (data && data[0] && data[0].details) {
          this.trailList = data[0].details.map(o => ({
            ...o
          }));
          this.isShowWaring && waybillNo?.length > 14 && await this.getWaringData()
          if (this.reversePOD) {
            this.trailList = this.trailList.reverse();
          }
        } else {
          this.isShowWaring && waybillNo?.length > 14 && this.getWaringData()
        }
        this.processData()
      } else {
        this.isShowWaring && waybillNo?.length > 14 && this.getWaringData()
        this.trailErrorMsg = msg;
      }
      // if (this.showNetInfo && this.trailList.length) {
      //   const ids = this.trailList.map(o => o.scanNetworkId).filter(o => o).join(',')
      //   const data = {
      //     networkIds: `[${ids}]`,
      //     waybillNo: waybillNo || ''
      //   }
      //   ids && detailView.queryByNetworkIds(data).then(({ data }) => {
      //     this.trailList = this.trailList.map((o, i) => {
      //       const itme = data.find(d => d.networkId === o.scanNetworkId)
      //       return {
      //         ...o,
      //         ...itme
      //       }
      //     })
      //   })
      // }
      // // 插入任务异常
      // const setTask = (o, index) => {
      //   this.trailList[index].taskList = []
      //   this.trailList[index].abnormalInfo = {}
      //   const { waybillTrackingContent, remark2 } = o
      //   const { beforeStr, afterStr } = this.addBracketMethod(waybillTrackingContent, remark2)
      //   detailView.queryException(remark2).then(({ data = {}}) => {
      //     const { abnormalSource, secondaryAbnormalInformation, shipmentException } = data[remark2]
      //     const { detailVOList, plannedArrivalTime, predictArrivalTime, shipmentState, actualArrivalTime } = shipmentException || {}
      //     this.$set(this.trailList, index, {
      //       ...this.trailList[index],
      //       abnormalInfo: secondaryAbnormalInformation || {},
      //       taskList: detailVOList || [],
      //       abnormalSource,
      //       plannedArrivalTime,
      //       predictArrivalTime,
      //       shipmentState,
      //       actualArrivalTime,
      //       taskStrBefore: beforeStr,
      //       taskStrAfter: afterStr
      //     })
      //   })
      // }
      // // 任务单号信息
      // if (this.abnormalTask && this.trailList.length) {
      //   this.trailList.map((o, i) => {
      //     if (o.scanTypeName === '装车扫描' && o.scanNetworkTypeId === '335') {
      //       o.remark2 && setTask(o, i)
      //     }
      //   })
      // }
      // // 插入经停列表
      // const setStop = (o, index) => {
      //   this.trailList[index].stopList = []
      //   const { waybillTrackingContent, remark2 } = o
      //   const { beforeStr, afterStr } = this.addBracketMethod(waybillTrackingContent, remark2)
      //   detailView.getStopList(remark2).then(({ data }) => {
      //     this.$set(this.trailList, index, {
      //       ...this.trailList[index],
      //       stopList: data || [],
      //       stopStrBefore: beforeStr,
      //       stopStrAfter: afterStr
      //     })
      //   })
      // }
      // // 经停列表
      // if (this.showStopList && this.trailList.length) {
      //   this.trailList.map((o, i) => {
      //     if (['装车扫描', '卸车扫描'].includes(o.scanTypeName) && o.scanNetworkTypeId === '335') {
      //       o.remark2 && setStop(o, i)
      //     }
      //   })
      // }

      // // 插入包号信息
      // const setPack = (o, index) => {
      //   this.trailList[index].packInfo = {}
      //   const { waybillTrackingContent, packageNumber } = o
      //   const { beforeStr, afterStr } = this.addBracketMethod(waybillTrackingContent, packageNumber)
      //   detailView.getPackInfo(packageNumber).then(({ data }) => {
      //     this.$set(this.trailList, index, {
      //       ...this.trailList[index],
      //       ...data,
      //       packStrBefore: beforeStr,
      //       packStrAfter: afterStr
      //     })
      //   })
      // }
      // // 包号信息
      // if (this.showPackInfo && this.trailList.length) {
      //   this.trailList.map((o, i) => {
      //     if (o.packageNumber) {
      //       setPack(o, i)
      //     }
      //   })
      // }

      // // 插入下一站信息
      // if (this.showNetLast && this.trailList.length) {
      //   const nids = this.trailList.map(o => o.nextNetworkId).filter(o => o).join(',')
      //   const ndata = {
      //     networkIds: `[${nids}]`,
      //     waybillNo: waybillNo || ''
      //   }
      //   nids && detailView.queryByNetworkIds(ndata).then(({ data }) => {
      //     this.trailList = this.trailList.map((o, i) => {
      //       const itme = data && data.find(d => d.networkId === parseInt(o.nextNetworkId))
      //       const { waybillTrackingContent, nextStopName } = o
      //       const { beforeStr, afterStr } = this.addBracketMethod(waybillTrackingContent, nextStopName)
      //       return {
      //         ...o,
      //         showNetLast: itme,
      //         nextStrBefore: beforeStr,
      //         nextStrAfter: afterStr
      //       }
      //     })
      //     console.log('this.trailList', this.trailList)
      //   })
      // }
    },
    async getWaringData() {
      this.waringData = {}
      if (!this.customerPhone && !this.waybillNo) return
      const { data } = await detailView.getWaringData({ waybillNo: this.waybillNo, mobilePhone: this.customerPhone })
      this.waringData = data || {}// 异常信息
      // 轨迹全部是问题件时不标记
      // const normalArr = this.trailList.filter(o => o.code !== 110)
      // if (!normalArr[0]) return
      // const { isNetworkException, colorLabel, isTaskException, taskNo, networkName } = data || {}
      // // 拼接处理
      // const networkNamProp = normalArr[0].nextStopName === networkName ? 'nextStopName' : 'scanNetworkName'
      // const { beforeStr, afterStr } = this.addBracketMethod(normalArr[0].waybillTrackingContent, normalArr[0][networkNamProp])
      // Object.assign(normalArr[0], {
      //   isNetworkException,
      //   abNetColorLabel: colorLabel,
      //   isTaskException,
      //   taskNo,
      //   normalNetworkName: normalArr[0][networkNamProp],
      //   abNextStrBefore: beforeStr,
      //   abNextStrAfter: afterStr
      // })
      // this.trailList = [...this.trailList]
    },
    // showOrderSignMixin中调用的
    // 获取集运一段二段
    async  getConsolidationTrailList(waybillNo, propList) {
      try {
        this[propList] = []
        if (!waybillNo) return
        const { data, code } = await detailView.traceDataList(waybillNo, this.allPod);
        if (code === RESPONSE_CODE.SUCCESS_COPY) {
          if (data && data[0] && data[0].details) {
            this[propList] = data[0].details.map(o => ({
              ...o
            }))
          }
          this.processData(propList)
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 处理数据
     */
    processData (propList) {
      const prop = propList || 'trailList'
      if (!this[prop].length || !this.showNetInfo && !this.abnormalTask && !this.showStopList && !this.showPackInfo) return
      // 标记过滤扫描类型：【问题件扫描、退件登记、退件撤销、退件扫描、拦截件扫描、拦截件登记、拦截件撤销】
      const codeList = [110, 170, 171, 172, 180, 190, 191]
      const normalArr = this[prop].filter(o => !codeList.includes(o.code))
      if (normalArr[0]) {
        this.$set(normalArr[0], 'isLatestTrack', true) // 标记过滤指定类型后的最新轨迹
      }
      const scanIds = [] // 网点id
      const nextIds = [] // 下一站id
      const packageNumberMap = {} // 缓存包号
      const resultMap = {} // 缓存异常网点信息，防止重复请求
      // const stopInfoMap = {} // 缓存经停列表
      this[prop].map((o, index) => {
        o.scanNetworkId && scanIds.push(o.scanNetworkId)
        o.nextNetworkId && nextIds.push(Number(o.nextNetworkId))
        // 扫描节点不是200（入库扫描）, 300（出库扫描），插入任务异常（旧逻辑）
        // 【发件扫描, 到件扫描, 集货到件, 中心到件, 装车扫描, 卸车扫描】才会返回任务号（新逻辑）
        if (o.remark2 && [50, 92, 91, 90, 40, 80].includes(o.code)) {
          this.setTaskInfo(o, index, resultMap, prop)
        }
        if (o.remark2 && o.scanNetworkTypeId === '335') {
          // if (o.scanTypeName === '装车扫描') {
          //   // 异常任务
          //   this.setTaskInfo(o, index, resultMap)
          // }
          if (['装车扫描', '卸车扫描'].includes(o.scanTypeName)) {
            // 插入经停列表
            // this.setStopInfo(o, index, stopInfoMap)
          }
        }
        if (o.packageNumber) {
          // 插入包号
          this.setPackInfo(o, index, packageNumberMap, prop)
        }
      })
      this.getNetworkInfo(scanIds, nextIds, prop)
    },
    /**
     * 插入任务异常
     */
    async setTaskInfo (o, index, resultMap, prop) {
      if (!this.abnormalTask) return
      this[prop][index].taskList = []
      this[prop][index].abnormalInfo = {}
      const { remark2 } = o
      if (!remark2) return
      if (!resultMap[remark2]) {
        resultMap[remark2] = detailView.queryException(remark2)
      }
      resultMap[remark2].then((result) => {
        const { data } = result
        if (!data) return
        const { abnormalSource, shipmentException } = data[remark2] || {}
        const { detailVOList, plannedArrivalTime, predictArrivalTime, shipmentState, actualArrivalTime } = shipmentException || {}
        this.$set(this[prop], index, {
          ...this[prop][index],
          isTask: true, // 任务号标识
          // abnormalInfo: secondaryAbnormalInformation || {},
          taskList: detailVOList || [],
          taskData: data,
          abnormalSource,
          plannedArrivalTime,
          predictArrivalTime,
          shipmentState,
          actualArrivalTime
        })
      })
    },
    /**
     * 插入经停列表
     */
    async setStopInfo (o, index, stopInfoMap) {
      const { remark2 } = o
      if (!this.showStopList) return
      this.trailList[index].stopList = []
      if (!stopInfoMap[remark2]) {
        stopInfoMap[remark2] = detailView.queryStopList(remark2)
      }
      stopInfoMap[remark2].then((result) => {
        const { data } = result
        this.$set(this.trailList, index, {
          ...this.trailList[index],
          stopList: data || []
        })
      })
    },
    /**
     * 插入包号信息
     * 查找已经调取接口的索引
     */
    async setPackInfo (o, index, packageNumberMap, prop) {
      const { packageNumber } = o
      if (!this.showPackInfo || !packageNumber) return
      this[prop][index].packInfo = {}
      if (!packageNumberMap[packageNumber]) {
        packageNumberMap[packageNumber] = detailView.getPackInfo(packageNumber)
      }
      packageNumberMap[packageNumber].then((result) => {
        const { data } = result
        this.$set(this[prop], index, {
          ...this[prop][index],
          ...data
        })
      })
    },
    async getNetworkInfo(scanIds, nextIds, prop) {
      const ids = [...scanIds, ...nextIds]
      if ((!this.showNetInfo && !this.showNetLast) || !ids.length) return
      const networkIds = `[${Array.from(new Set(ids)).join(',')}]`
      const result = await detailView.queryByNetworkIds({ networkIds, waybillNo: this.waybillNo })
      const netList = result?.data || []
      this[prop] = this[prop].map(t => {
        return {
          ...t,
          ...this.getCurNetInfo(t, netList),
          ...this.getNextNetInfo(t, netList)
        }
      })
    },
    /**
     * 扫描网点信息
     */
    getCurNetInfo (trail, netList) {
      if (!this.showNetInfo || !netList.length) return {}
      const target = netList?.find(n => n.networkId === parseInt(trail.scanNetworkId)) || {}
      return target
    },
    /**
     * 下一站网点信息
     */
    getNextNetInfo (trail, netList) {
      if (!this.showNetLast || !netList.length) return {}
      const target = netList?.find(n => n.networkId === parseInt(trail.nextNetworkId)) || {}
      // 拼接记录描述
      return { showNetLast: target }
    },
    addBracketMethod(waybillTrackingContent, showTipTag) { // 加括号处理截取字符
      let [startSign, endSign, beforeStr, afterStr] = ['【', '】', '', '']
      if (waybillTrackingContent.includes('[')) { // 中英文匹配不同
        startSign = '['
        endSign = ']'
      }
      if (waybillTrackingContent && showTipTag) {
        const str = startSign + showTipTag + endSign
        const strArr = waybillTrackingContent.split(str).length > 2// 如果目标截取项有重复的
        if (strArr) {
          // 先拿到第一个目标截取项的索引，再从第一个往后找
          beforeStr = waybillTrackingContent.substring(0, waybillTrackingContent.indexOf(str, waybillTrackingContent.indexOf(str) + 1)) + startSign// 只截取重复的第二个
          afterStr = endSign + waybillTrackingContent.substring(beforeStr + str, '')
        } else {
          beforeStr = (waybillTrackingContent.split(str)[0] || '') + startSign
          afterStr = endSign + (waybillTrackingContent.split(str)[1] || '')
        }
      }
      return { beforeStr, afterStr }
    },
    async getOrderInfo({ waybillNo, decode, orderId, isOrder }) {
      let reqFn, param;
      if (isOrder) {
        reqFn = detailView.getOmsOrderById
        param = orderId
      } else {
        if (decode) {
          // 反查BS基础信息
          if (this.checkBs) return this.getBsInfo(waybillNo, decode)
          reqFn = detailView.reqOrderInfoPlaintext;
          param = {
            waybillId: waybillNo,
            queryReason: this.logoTitle ? this.logoTitle : 'QT'
          };
        } else {
          reqFn = detailView.reqWaybillInfo;
          param = {
            waybillNos: waybillNo
          };
        }
        if (!decode) {
          this.orderInfo = {};
        }
      }
      await reqFn(param).then(({ data }) => {
        if (isOrder && data) {
          this.orderInfo = data || {}
        } else {
          if (data && data[0]) {
            this.orderInfo = data[0];
          } else if (decode && data) {
            // 当查询的返回结果都为null的时候,代表查询失败不重置数据
            if (Object.keys(data).filter(v => !!data[v]).length <= 0) {
              this.$message.error(this.$lang('反查数据异常，请核实订单信息。'));
              return;
            }
            this.orderInfo = {
              ...this.orderInfo
              // ...data
            };
          } else {
            this.getBsInfo(waybillNo, decode)
          }
        }
        // this.getCustomerType()
        this.$emit('pickUpNetworkName', this.orderInfo.pickUpNetworkName);
      });
      await this.getOrderLabel(waybillNo, 'orderInfo')// 请求订单标签
      // this.orderInfo.senderMobilePhone =
      //   this.orderInfo.senderMobilePhone || this.orderInfo.senderTelphone;
      // this.orderInfo.receiverMobilePhone =
      //   this.orderInfo.receiverMobilePhone || this.orderInfo.receiverTelphone;
      this.orderInfo.virtualNumber = this.orderInfo.virtualNumber || '--'
      this.$emit('getOrderInfo', this.orderInfo);
    },
    async getBsInfo(waybillNo, decode) {
      let reqFn, param
      // 是否是百世勾选 且没有点小眼睛
      if (!decode) {
        reqFn = detailView.queryBillBs
        param = {
          billCodes: [waybillNo]
        }
      } else { // 是否是百世勾选 点小眼睛
        reqFn = detailView.queryBillSensitive
        param = {
          billCode: waybillNo
        }
      }
      if (!decode) {
        this.orderInfo = {}
      }
      await reqFn(param).then(({ data }) => {
        if (data && data[0]) {
          this.checkBs = true
          this.orderInfo = data[0]
        } else if (decode && data) {
          // 当查询的返回结果都为null的时候,代表查询失败不重置数据
          if (Object.keys(data).filter(v => !!data[v]).length <= 0) {
            this.$message.error(this.$lang('反查数据异常，请核实订单信息。'))
            return
          }
          this.orderInfo = {
            ...this.orderInfo
            // ...data
          }
        }
      })
      // this.orderInfo.senderMobilePhone = this.orderInfo.senderMobilePhone || this.orderInfo.senderTelphone
      // this.orderInfo.receiverMobilePhone = this.orderInfo.receiverMobilePhone || this.orderInfo.receiverTelphone
      this.orderInfo.virtualNumber = this.orderInfo.virtualNumber || '--'
      this.$emit('getOrderInfo', this.orderInfo)
    },
    async getProblemList(waybillNo) {
      try {
        this.problemList = [];
        this.problemDetailErrorMsg = '';
        const { data, msg, code } = await detailView.getProblemPieceList(waybillNo)
        if (code === RESPONSE_CODE.SUCCESS) {
          this.problemList = (data || []).map(o => {
            o.detailCount = o.serviceRecordCount || '0';
            return o;
          });
        } else {
          console.log('getProblemList', msg)
          this.problemDetailErrorMsg = this.$lang('问题件服务不可用')
        }
      } catch (e) {
        console.log('getProblemList', e)
        this.problemDetailErrorMsg = this.$lang('问题件服务不可用')
      }
    },
    // 请求百世单号轨迹信息
    // async getImmortalTrail(waybillNo) {
    //   if (!waybillNo || waybillNo.substr(0, 2) !== '55') {
    //     this.immortalTrailList = []
    //     return
    //   }
    //   try {
    //     const { data, msg, code } = await detailView.getQueryBs({ billCodes: [waybillNo] })
    //     if (code === RESPONSE_CODE.SUCCESS) {
    //       this.immortalTrailList = data
    //     } else {
    //       this.immortalTrailListErrorMsg = msg
    //     }
    //   } catch (e) {
    //     console.log(e);
    //   }
    // },
    async getProblemMinList(id) {
      this.problemMinList = [];
      detailView.getproblemServiceRecordList(id).then(({ data }) => {
        this.problemMinList = data || [];
      });
    },
    async getWorkOrderList(waybillNo) {
      try {
        this.workOrderList = [];
        this.workOrderListAll = [];
        this.workOrderListErrorMsg = '';
        const { data, msg, code } = await detailView.getWorkOrderList(waybillNo)
        if (code === RESPONSE_CODE.SUCCESS) {
          const dataAll = (data || []).map(o => {
            o.detailCount = o.processRecords?.length || '0';
            return o;
          }) || []
          // 设置客服工单
          this.workOrderListAll = dataAll
          this.workOrderList = dataAll;
          this.setCustomerServiceOrder('workOrderListAll', dataAll)
          // dataAll.reverse();
          // if (dataAll.length > 1) {
          //   this.workOrderListAll = dataAll.splice(0, 1);
          //   this.workOrderList = dataAll;
          // } else if (dataAll.length === 1) {
          //   this.workOrderListAll = dataAll;
          // } else {
          //   this.workOrderList = [];
          //   this.workOrderListAll = [];
          // }
        } else {
          console.log('getWorkOrderList', msg)
          this.workOrderListErrorMsg = this.$lang('工单服务不可用')
        }
      } catch (e) {
        console.log('getWorkOrderList', e)
        this.workOrderListErrorMsg = this.$lang('工单服务不可用')
      }
    },
    setWorkOrderMinList(item) {
      this.workOrderMinList = item.processRecords || [];
      console.log(this.workOrderMinList, 'neirong');
      // 分离文件和图片
      item.processRecords.find((o, index) => {
        console.log(o, index);
        if (o.urls) {
          const urls = o.urls;
          const imgs = [];
          const files = [];
          urls.map(o => {
            o.match(/(^data\:image\/)|(\.(jpe?g|png|gif))/i)
              ? imgs.push(o)
              : files.push(o);
          });
          this.workOrderMinList[index].enclosure = [];
          this.workOrderMinList[index].enclosure[0] = imgs;
          this.workOrderMinList[index].enclosure[1] = files;
        }
      });

      console.log(this.workOrderMinList, 'neirong');
    },
    setWorkOrderMinListAll(item) {
      this.workOrderMinListAll = item.processRecords || [];
      console.log(this.workOrderMinListAll, 'neirong', 1111111111111);
      // 分离文件和图片
      item.processRecords.find((o, index) => {
        console.log(o, index);
        if (o.urls) {
          const urls = o.urls;
          const imgs = [];
          const files = [];
          urls.map(o => {
            o.match(/(^data\:image\/)|(\.(jpe?g|png|gif))/i)
              ? imgs.push(o)
              : files.push(o);
          });
          this.workOrderMinListAll[index].enclosure = [];
          this.workOrderMinListAll[index].enclosure[0] = imgs;
          this.workOrderMinListAll[index].enclosure[1] = files;
        }
      });
      console.log(this.workOrderMinListAll, 11111);
    },
    async getArbitrationList(waybillNo) {
      try {
        this.arbitrationList = [];
        this.arbitrationListErrorMsg = ''
        const { data, msg, code } = await detailView.getArbitrationList(waybillNo)
        if (code === RESPONSE_CODE.SUCCESS) {
          this.arbitrationList = data || [];
        } else {
          console.log('getArbitrationList', msg)
          this.arbitrationListErrorMsg = this.$lang('仲裁工单服务不可用')
        }
      } catch (e) {
        console.log('getArbitrationList', e)
        this.arbitrationListErrorMsg = this.$lang('仲裁工单服务不可用')
      }
      // 设置客服工单
      this.setCustomerServiceOrder('arbitrationList', this.arbitrationList)
    },
    async getQualityList(waybillNo) {
      try {
        this.qualityList = [];
        this.qualityListErrorMsg = '';
        const { data, msg, code } = await detailView.getQualityList(waybillNo)
        if (code === RESPONSE_CODE.SUCCESS) {
          this.qualityList = (data || []).map(o => {
            o.detailCount = o.problemExpressWoLogIntegrationVOS.length || '0';
            return o;
          });
        } else {
          console.log('getQualityList', msg)
          this.qualityListErrorMsg = this.$lang('质量工单服务不可用')
        }
      } catch (e) {
        console.log('getQualityList', e)
        this.qualityListErrorMsg = this.$lang('质量工单服务不可用')
      }
      // 设置客服工单
      this.setCustomerServiceOrder('qualityList', this.qualityList)
    },
    setQualityMinList(item) {
      this.qualityMinList = item.problemExpressWoLogIntegrationVOS || [];
    },
    async getImgUrl(item) {
      await detailView
        .reqReviewImage({
          waybillNo: item.waybillNo,
          scanTime: item.scanTime,
          scanByCode: item.scanByCode,
          imgType: item.imgType
        })
        .then(({ data }) => {
          this.handleShowImg(data || []);
        });
    },
    handleShowImg(url = [], keyName, isDownload) {
      if (keyName) {
        url = url.map(o => o[keyName]);
      }
      const imgs = url.filter(o => o.match(/\.(jpe?g|png|gif)(\?\S+)?$/));
      this.$openImagePreview(imgs);
      url.map(file => {
        if (!file.match(/\.(jpe?g|png|gif)(\?\S+)?$/)) {
          isDownload && window.open(file);
        }
      });
    },
    // 请求来电记录
    async getCallRecords(waybillNo) {
      try {
        this.callRecordsErrorMsg = ''
        const { code, data, msg } = await detailView.getCallRecord(waybillNo);
        if (code === RESPONSE_CODE.SUCCESS) {
          data && data.map(item => {
            item.showPhoneEyes = true
            item.showCallBackPhoneEyes = true
            return item
          })
          this.CallRecordsList = data
        } else {
          console.log('getCallRecords', msg);
          this.callRecordsErrorMsg = this.$lang('来访记录服务不可用')
        }
      } catch (err) {
        console.log('getCallRecords', err);
        this.callRecordsErrorMsg = this.$lang('来访记录服务不可用')
      }
    },
    // 短信记录
    async getSmslogs(waybillNo) {
      try {
        const { code, data, msg } = await detailView.queryMsgRecord(waybillNo);
        if (code === RESPONSE_CODE.SUCCESS) {
          this.smsLogsErrorMsg = ''
          data && data.map(item => {
            item.callPhone = item.phone
            item.showPhoneEyes = true
            return item
          })
          this.smsLogsErrorList = data || [];
        } else {
          this.smsLogsErrorMsg = msg
        }
      } catch (err) {
        this.smsLogsErrorMsg = this.$lang('短信记录服务不可用')
      }
    },
    // 更改父组件来访记录电话
    showPhoneEyes(e, propList) {
      if (e[2] !== '') {
        const callObj = this[propList][e[2]]
        callObj.showPhoneEyes = true
        this[propList].splice(e[2], 1, callObj)
      }
      this[propList].splice(e[1], 1, e[0])
    },
    /**
     * 请求邮政工单信息
     */
    async getPostalInfo(waybillNo) {
      try {
        const { code, data, msg } = await detailView.getPostalInfo({ waybillNo: waybillNo })
        if (code === RESPONSE_CODE.SUCCESS) {
          this.postalOrderAllList = (data || []).map(o => {
            o.detailCount = o.processRecordList.length || '0'
            return o
          })
        } else {
          this.postalOrderErrorMsg = msg
        }
      } catch (error) {
        console.log(error);
      }
      // 设置客服工单
      this.setCustomerServiceOrder('postalOrderAllList', this.postalOrderAllList)
    },
    /**
     * 邮政工单信息子
     */
    setPostalOrderList(item) {
      this.postalOrderList = item.processRecordList || []
    },
    // 请求详细地址
    async getAddressDetail({ waybillNo }) {
      if (!waybillNo) return
      const { data } = await detailView.getAddressDetail(waybillNo)
      this.orderInfo = { ...this.orderInfo, addressDetail: data || true }
    },
    // IM质检数据
    postModelData(data) {
      this.imModelTableLength = data.total
    },
    // 整合客服工单
    setCustomerServiceOrder(list, dataList) {
      if (!list) { // 清空处理
        Object.assign(this.customerServiceOrder, {
          workOrderListAll: [],
          postalOrderAllList: [],
          arbitrationList: [],
          qualityList: [],
          num: 0
        })
        return
      }
      Object.assign(this.customerServiceOrder, {
        [list]: dataList || [],
        num: this.workOrderListAll.length + this.postalOrderAllList.length + this.arbitrationList.length + this.qualityList.length
      })
    },
    // 取件码
    async getPickupcode(waybillNo) {
      try {
        const { code, data, msg } = await detailView.getPickupcode({
          current: 1,
          size: 200,
          billCodes: [waybillNo]
        })
        if (code === RESPONSE_CODE.SUCCESS) {
          this.PickupCodeErrorMsg = ''
          this.PickupcodeList = data.records || []
          this.PickupTotal = data.total || 0
        } else {
          console.log(msg);
          this.PickupCodeErrorMsg = this.$lang('取件码服务不可用')
        }
      } catch (err) {
        console.log(err);
        this.PickupCodeErrorMsg = this.$lang('取件码服务不可用')
      }
    },
    // 是否寄件人
    async getCustomerType() {
      this.showbackTransfer = false
      if (this.waybillNo && this.customerPhone) {
        const { code, data, msg } = await BackTransferApi.reqCustomerType({
          waybillNo: this.waybillNo,
          customerPhone: this.customerPhone
        })
        this.showbackTransfer = data === 1
        console.log(code, data, msg, '>>>>接口')
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.model-preview {
  width: 100%;
  ::v-deep .main-wrap {
    height: calc(100vh - 175px) !important;
    padding: 0px;
  }
}
</style>
<style lang="scss">
.detail-right {
  width: 100%;
  height: 100%;
  .detail-tabs {
    width: 100%;
    height: 100%;
    .el-tabs__item {
      line-height: 26px;
      height: 26px;
      color: #999;
      font-weight: normal;
    }
    .el-tabs__content {
      overflow: auto;
      height: calc(100% - 41px);
    }
  }
  .total-view {
    display: inline-block;
    background-color: #e60012;
    min-width: 16px;
    padding: 0 4px;
    height: 16px;
    border-radius: 8px;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    color: #fff;
  }
  .label-margin {
    margin-right: 10px;
  }
  .el-tabs__nav-next,
  .el-tabs__nav-prev {
    line-height: 26px;
  }
}
</style>
